/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Disconnect_KeptInputs */



/**
* | output |
* | --- |
* | "Your earlier conversations, reports and transcripts are kept." |
*
* @param {Connections_Disconnect_KeptInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_disconnect_kept = /** @type {((inputs?: Connections_Disconnect_KeptInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Disconnect_KeptInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je eerdere gesprekken, verslagen en transcripties blijven bewaard.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos conversations passées, comptes rendus et transcriptions sont conservés.")
	return /** @type {LocalizedString} */ ("Your earlier conversations, reports and transcripts are kept.")
});